import { Box, Typography, Button, Container } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Link } from 'react-router-dom';

const PaymentSuccess = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#d1e7dd',
      }}
    >
      <Container maxWidth='sm' sx={{ textAlign: 'center', padding: 4 }}>
        <CheckCircleOutlineOutlinedIcon
          sx={{
            fontSize: '100px',
            color: '#28a745',
            marginBottom: 2,
          }}
        />
        <Typography
          variant='h4'
          gutterBottom
          sx={{ fontWeight: 'bold', color: '#28a745' }}
        >
          Transaction Successful
        </Typography>
        <Typography
          variant='body1'
          sx={{
            marginBottom: 3,
            color: '#6c757d',
          }}
        >
          Your transaction has been completed successfully. Thank you for using
          our service!
        </Typography>
        <Link to={'/new-member-applications'}>
          <Button
            variant='contained'
            color='success'
            size='large'
            sx={{
              padding: '10px 30px',
              borderRadius: '30px',
              textTransform: 'none',
              fontSize: '16px',
            }}
          >
            Go to Homepage
          </Button>
        </Link>
      </Container>
    </Box>
  );
};

export default PaymentSuccess;
